(() => {
  const STICKY_SELECTOR = "[data-xts-sticky-atc]";
  const PRODUCT_TEMPLATE_CLASS = "template-product";
  const ANNOUNCEMENT_ALWAYS_CLASS = "xts-product-announcement-always";
  let lastScrollY = window.scrollY || window.pageYOffset || 0;
  let scrollDirection = "none";

  function isProductPage() {
    return document.body.classList.contains(PRODUCT_TEMPLATE_CLASS) || Boolean(document.querySelector("product-info"));
  }

  function getProductStickyPosition() {
    return (
      document.querySelector("[data-xts-product-sticky-atc-position]")?.dataset.xtsProductStickyAtcPosition ||
      "bottom"
    );
  }

  function getAnnouncementBar() {
    return document.querySelector(".announcement-bar-section");
  }

  function hasAlwaysVisibleAnnouncement() {
    return (
      isProductPage() &&
      document.querySelector('[data-xts-announcement-visible="always"]')
    );
  }

  function syncAnnouncementHeight() {
    const announcementBar = getAnnouncementBar();
    const shouldKeepAnnouncementVisible = Boolean(hasAlwaysVisibleAnnouncement());
    const announcementHeight = shouldKeepAnnouncementVisible && announcementBar ? announcementBar.offsetHeight : 0;

    document.body.classList.toggle(ANNOUNCEMENT_ALWAYS_CLASS, shouldKeepAnnouncementVisible);
    document.documentElement.style.setProperty("--xts-announcement-height", `${announcementHeight}px`);
  }

  function syncScrollDirection() {
    const currentScrollY = window.scrollY || window.pageYOffset || 0;

    if (currentScrollY > lastScrollY) {
      scrollDirection = "down";
    } else if (currentScrollY < lastScrollY) {
      scrollDirection = "up";
    }

    lastScrollY = currentScrollY;
  }

  function initStickyBar(stickyBar) {
    if (stickyBar.dataset.xtsStickyAtcInitialized === "true") return;

    const sectionId = stickyBar.dataset.sectionId;
    if (!sectionId) return;

    const mainProductSection = document.getElementById(`MainProduct-${sectionId}`);
    const footerElement = document.querySelector("#shopify-section-footer, footer.footer, .footer");
    const sourceSubmitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const stickySubmitButton = stickyBar.querySelector("[data-xts-sticky-atc-submit]");
    const stickyPrice = stickyBar.querySelector("[data-xts-sticky-atc-price]");
    const stickyLabel = stickyBar.querySelector(".xts-sticky-atc__submit-label");

    if (!mainProductSection || !sourceSubmitButton || !stickySubmitButton || !stickyPrice || !stickyLabel) return;

    stickyBar.dataset.xtsStickyAtcInitialized = "true";

    const stickyPosition = getProductStickyPosition() === "top" ? "top" : "bottom";
    stickyBar.classList.toggle("xts-sticky-atc--top", stickyPosition === "top");
    stickyBar.classList.toggle("xts-sticky-atc--bottom", stickyPosition === "bottom");

    const addToCartLabel = stickyBar.dataset.addToCartLabel || "Add to cart";
    const soldOutLabel = stickyBar.dataset.soldOutLabel || "Sold out";
    const unavailableLabel = stickyBar.dataset.unavailableLabel || "Unavailable";

    const syncButtonState = () => {
      const isDisabled =
        sourceSubmitButton.hasAttribute("disabled") ||
        sourceSubmitButton.getAttribute("aria-disabled") === "true";

      stickySubmitButton.disabled = isDisabled;
      stickySubmitButton.setAttribute("aria-disabled", isDisabled ? "true" : "false");
      stickySubmitButton.classList.toggle("loading", sourceSubmitButton.classList.contains("loading"));

      const sourcePrices = sourceSubmitButton.querySelector(".product-form__submit-prices");
      let buttonLabel = addToCartLabel;
      const sourceLabel = sourceSubmitButton.querySelector("span");
      const labelText = sourceLabel
        ? sourceLabel.childNodes[0]?.textContent?.trim().toLowerCase() || ""
        : "";

      if (labelText === soldOutLabel.toLowerCase()) {
        buttonLabel = soldOutLabel;
      } else if (labelText === unavailableLabel.toLowerCase()) {
        buttonLabel = unavailableLabel;
      } else if (isDisabled && !sourcePrices) {
        buttonLabel = soldOutLabel;
      }

      stickyLabel.textContent = buttonLabel;

      if (sourcePrices && buttonLabel === addToCartLabel) {
        stickyPrice.hidden = false;
        stickyPrice.innerHTML = sourcePrices.innerHTML;
      } else {
        stickyPrice.hidden = true;
        stickyPrice.textContent = "";
      }
    };

    const updateVisibility = () => {
      const sourceRect = sourceSubmitButton.getBoundingClientRect();
      const isSourceButtonVisible =
        sourceRect.bottom > 0 &&
        sourceRect.top < window.innerHeight &&
        sourceRect.right > 0 &&
        sourceRect.left < window.innerWidth &&
        window.getComputedStyle(sourceSubmitButton).display !== "none" &&
        window.getComputedStyle(sourceSubmitButton).visibility !== "hidden";
      const hasPassedSourceButton = sourceRect.bottom <= 0;

      const stickyHeight = stickyBar.offsetHeight || 0;
      const isFooterCollision = footerElement
        ? footerElement.getBoundingClientRect().top <= (window.innerHeight - stickyHeight)
        : false;
      const isNearPageBottom =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      const shouldShow =
        stickyPosition === "top"
          ? hasPassedSourceButton && scrollDirection === "down"
          : !isSourceButtonVisible && !isFooterCollision && !isNearPageBottom;

      stickyBar.classList.toggle("is-visible", shouldShow);
      document.body.classList.toggle("xts-sticky-atc-visible", shouldShow);
    };

    const scheduleVisibilityUpdate = () => {
      syncScrollDirection();
      syncAnnouncementHeight();
      window.requestAnimationFrame(updateVisibility);
    };

    stickySubmitButton.addEventListener("click", (event) => {
      event.preventDefault();
      if (sourceSubmitButton.hasAttribute("disabled") || sourceSubmitButton.getAttribute("aria-disabled") === "true") return;
      sourceSubmitButton.click();
    });

    const submitButtonObserver = new MutationObserver(syncButtonState);
    submitButtonObserver.observe(sourceSubmitButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    let variantUnsubscribe = null;
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || data.sectionId !== sectionId) return;
        syncButtonState();
      });
    }

    const cleanup = () => {
      submitButtonObserver.disconnect();
      variantUnsubscribe?.();
      window.removeEventListener("scroll", scheduleVisibilityUpdate);
      window.removeEventListener("resize", scheduleVisibilityUpdate);
      if (!document.querySelector(`${STICKY_SELECTOR}.is-visible`)) {
        document.body.classList.remove("xts-sticky-atc-visible");
      }
    };

    const disconnectObserver = new MutationObserver(() => {
      if (!stickyBar.isConnected || !mainProductSection.isConnected) {
        cleanup();
        disconnectObserver.disconnect();
      }
    });
    disconnectObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener("scroll", scheduleVisibilityUpdate, { passive: true });
    window.addEventListener("resize", scheduleVisibilityUpdate);

    syncAnnouncementHeight();
    syncButtonState();
    updateVisibility();
  }

  function initAllStickyBars() {
    syncAnnouncementHeight();
    document.querySelectorAll(STICKY_SELECTOR).forEach(initStickyBar);
  }

  window.addEventListener(
    "scroll",
    syncScrollDirection,
    { passive: true }
  );

  window.addEventListener("resize", syncAnnouncementHeight);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllStickyBars);
  } else {
    initAllStickyBars();
  }

  document.addEventListener("shopify:section:load", initAllStickyBars);
})();
